"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlobPathFromURI = void 0;
function getBlobPathFromURI(uri) {
    const filePathExtractor = /^https?:\/\/.*?\/.*?\/(.*?)(\?.*)?$/.exec(uri);
    const filePath = filePathExtractor ? filePathExtractor[1] : undefined;
    if (!filePath) {
        throw new Error("Could not process file path");
    }
    return filePath;
}
exports.getBlobPathFromURI = getBlobPathFromURI;
//# sourceMappingURL=blob-path-extractor.js.map